import scaleAnimations from './scale';
import fadeAnimations from './fade';
import slideAnimations from './slide';
export default Object.assign({}, fadeAnimations, scaleAnimations, slideAnimations);